import { EmptyState } from './EmptyState';

interface EmptyYearStateProps {
  /** Exercise that has no exploitable data. */
  year: number;
  /** Current calendar year — defaults to today. Used for the recovery button label. */
  currentYear?: number;
  /** Called when the user asks to return to the current exercise. */
  onReturnToCurrentYear: () => void;
  description?: string;
  /** `block` fills the empty area (dashboard); `banner` sits above visible content (calendar). */
  variant?: 'block' | 'banner';
}

export function EmptyYearState({
  year,
  currentYear = new Date().getFullYear(),
  onReturnToCurrentYear,
  description,
  variant = 'block',
}: EmptyYearStateProps) {
  const title = `Aucune donnée pour l'exercice ${year}`;
  const isCurrentYear = year === currentYear;
  const buttonLabel = `Revenir à ${currentYear}`;

  if (variant === 'banner') {
    return (
      <div className="empty-year-banner" role="status">
        <div className="empty-year-banner__text">
          <strong>{title}</strong>
          {description ? <span>{description}</span> : null}
        </div>
        {isCurrentYear ? null : (
          <button className="button button--ghost" type="button" onClick={onReturnToCurrentYear}>
            {buttonLabel}
          </button>
        )}
      </div>
    );
  }

  return (
    <EmptyState
      icon="◔"
      title={title}
      description={description ?? 'Aucune activité enregistrée sur cet exercice.'}
      action={isCurrentYear ? undefined : { label: buttonLabel, onClick: onReturnToCurrentYear }}
    />
  );
}
